import { render, staticRenderFns } from "./StudentDashboard.vue?vue&type=template&id=42680ad9&scoped=true"
import script from "./StudentDashboard.vue?vue&type=script&lang=js"
export * from "./StudentDashboard.vue?vue&type=script&lang=js"
import style0 from "./StudentDashboard.vue?vue&type=style&index=0&id=42680ad9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42680ad9",
  null
  
)

export default component.exports